<!-- Desktop sidebar -->
<div class="layout-sidebar">
  <sm-layout-menu></sm-layout-menu>
</div>